import { SearchBar } from "../../shared/search-bar/search-bar"
import React from "react"
import ReactDom from "react-dom"
import lunr from "lunr"

type SearchBarProps = {
  documents: Array<Entity>
  lunrIndex: lunr.Index
  entity: string
}

type Entity = {
  title: string
  path: string
  preview_text?: string
  contributors?: string
}

export default function indexSearch(
  el: HTMLElement,
  { documents, entity }: SearchBarProps,
) {
  const lunrIndex = lunr(function () {
    this.ref("path")
    this.field("title")
    this.field("contributors")
    this.field("preview_text")
    for (let i = 0; i < documents.length; i++) {
      this.add(documents[i])
    }
  })

  ReactDom.render(
    <SearchBar
      documents={documents}
      lunrIndex={lunrIndex}
      entityName={entity}
    />,
    el,
  )
}
